module.exports = __webpack_public_path__ + "static/rohit-raj-_vBGmvQWZnw-unsplash-crop-2-ab972c444274b4e801d661d59fbe44ad.jpg";